import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import {
    Box,
    TextField,
    Stack,
    Backdrop,
    Paper,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    Typography
} from "@mui/material";

import CustomButton from "../custom_components/CustomButton";
import CustomModalHeader from "../custom_components/CustomModalHeader";

import { UserContext } from "../../context/UserContext";

export default function EditItem({ open, onClose, selectedItem, onUpdate }) {

    const apiUrl = process.env.REACT_APP_API_URL;

    const { categories } = useContext(UserContext);

    const [loadingSave, setLoadingSave] = useState(false);

    const [form, setForm] = useState({
        id: null,
        itemId: "",
        name: "",
        category: "",
        stock: "",
        price: "",
        image: ""
    });

    // console.log(selectedItem)

    const [category, setCategory] = useState("");

    // ✅ Fill form when opening edit modal
    useEffect(() => {
        if (selectedItem) {
            setForm({
                id: selectedItem.id || null,
                itemId: selectedItem.ItemID || "",
                name: selectedItem.ItemName || "",
                category: selectedItem.Category || "",
                stock: selectedItem.Stock || "",
                price: selectedItem.Price || "",
                image: selectedItem.ItemImg || "",
            });
        }
    }, [selectedItem]);

    const handleClose = () => {
        setForm({
            id: null,
            itemId: "",
            name: "",
            category: "",
            stock: "",
            price: "",
            image: ""
        });
        onClose(false);
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleUpdateItem = async () => {
        try {
            setLoadingSave(true);

            const response = await fetch(`${apiUrl}manage_inventory/edit_item.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(form),
            });

            const result = await response.json();

            if (result.status === "success") {

                Swal.fire({
                    text: result.message,
                    icon: "success",
                });

                onUpdate(form);

                handleClose();
            } else {
                Swal.fire({
                    text: result.message,
                    icon: "error",
                });
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingSave(false);
        }
    };

    return (
        <Backdrop
            aria-hidden="false"
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backdropFilter: "blur(1px)",
            }}
        >
            <Paper
                sx={{
                    width: 400,
                    p: 3,
                    borderRadius: 2,

                    position: "relative",
                    overflow: "hidden",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "4px",
                        background: "#2e3489"
                    }
                }}
            >

                <CustomModalHeader
                    title="Edit List"
                    subtitle={`ID: ${form.itemId}`}
                    onClose={handleClose}
                />

                <Box display="flex" flexDirection="column" gap={2} mt={3}>
                    <TextField
                        size='small'
                        label="Item Name"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        fullWidth
                    />
                    <FormControl fullWidth size='small'>
                        <InputLabel id="demo-select-small-label">
                            Category
                        </InputLabel>
                        <Select
                            name="category"
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            defaultValue="Watch"
                            value={form.category}
                            label="Category"
                            onChange={handleChange}
                        >
                            {categories.map((category, index) => (
                                <MenuItem key={index} value={category.ItemCategory}>
                                    {category.ItemCategory}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                        size='small'
                        label="Stock"
                        name="stock"
                        type="number"
                        value={form.stock}
                        onChange={handleChange}
                        fullWidth
                    />
                    <TextField
                        size='small'
                        label="Price"
                        name="price"
                        value={form.price}
                        onChange={handleChange}
                        fullWidth
                    />
                    <Stack direction="row" alignItems="center" gap={2}>
                        <TextField
                            size='small'
                            label="Image Name"
                            name="image"
                            value={form.image}
                            onChange={handleChange}
                            fullWidth
                        />
                        <Typography>
                            .jpg
                        </Typography>
                    </Stack>
                </Box>

                <Stack direction="row" spacing={2} mt={3} justifyContent="flex-end">
                    <CustomButton
                        label="Cancel"
                        variant="outlined"
                        hoverColor="#d14249"
                        onClick={handleClose}
                    />

                    <CustomButton
                        label={loadingSave ? "Updating..." : "Update"}
                        disabled={loadingSave}
                        onClick={handleUpdateItem}
                    />
                </Stack>

            </Paper>

        </Backdrop>
    );
}
